module.exports = __webpack_public_path__ + "img/chinaMap2.06532c74.png";